import React from "react";
import styles from "./ActivityIndicator.module.css";

const ActivityIndicator = ({ text, loading }) => {
  return (
    <>
      {loading && (
        <div className={styles.indicatorDiv}>
          <div className={styles.spinnersDiv}>
            <div className={styles.spinners} />
            <p className={styles.logoPrimary}>
              metro<span className={styles.logoSecondary}>net</span>
            </p>
          </div>
          {text && <p className={styles.statusText}>{text}</p>}
        </div>
      )}
    </>
  );
};

export default ActivityIndicator;
